import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SLUGS from 'resources/routesConstants';
import LoadingComponent from 'components/loading/loader';
import { useAuthStore } from '@/stores/auth-store';

const DashboardComponent = lazy(() => import('../components/Homepage'));
const Profile = lazy(() => import('../components/Profile'));
const Security = lazy(() => import('../components/Security'));
const Licenses = lazy(() => import('../components/Licenses'));
const Subscription = lazy(() => import('../components/Subscriptions'));
const Support = lazy(() => import('../components/Support'));

// v2 feature pages
const Credits = lazy(() => import('../components/Credits'));
const PurchaseHistory = lazy(() => import('../components/PurchaseHistory'));
const Verification = lazy(() => import('../components/Verification'));
const HealthSystems = lazy(() => import('../components/HealthSystems'));
const Messaging = lazy(() => import('../components/Messaging'));
const Orders = lazy(() => import('../components/Orders'));

// DSC-1A.2 — Notification Preferences (Wave 1, data-storage consolidation)
const NotificationPrefs = lazy(() => import('../components/NotificationPrefs'));

// DSC-1B.2 — Account Display Preferences (Wave 1, data-storage consolidation)
const AccountDisplayPrefs = lazy(() => import('../components/AccountDisplayPrefs'));

// ABDM M1 — ABHA / Health ID management
const Abha = lazy(() => import('../components/Abha'));
const Hpr = lazy(() => import('../components/Hpr'));


function PrivateRoutes({userRole}) {
    // Professional-only: HPR is for clinicians, not patients. Block direct-URL
    // access (the sidebar item is also gated on this).
    const isClinician = useAuthStore((s) => s.isClinician)();
    return (
        <Suspense fallback={<LoadingComponent/>}>
            <Routes>
                <Route path={SLUGS.dashboard} element={<DashboardComponent />} />
                <Route path={SLUGS.profile} element={<Profile />} />
                <Route path={SLUGS.subscriptions} element={<Subscription />} />
                <Route path={SLUGS.security} element={<Security />} />
                <Route path={SLUGS.licenses} element={<Licenses />} />
                <Route path={SLUGS.support} element={<Support />} />

                {/* v2 feature pages */}
                <Route path={SLUGS.credits} element={<Credits />} />
                <Route path={SLUGS.purchaseHistory} element={<PurchaseHistory />} />
                <Route path={SLUGS.orders} element={<Orders />} />
                <Route path={SLUGS.verification} element={<Verification />} />
                <Route path={SLUGS.healthSystems} element={<HealthSystems />} />
                <Route path={SLUGS.messages} element={<Messaging />} />
                <Route path={SLUGS.notificationPrefs} element={<NotificationPrefs />} />
                <Route path={SLUGS.accountDisplayPrefs} element={<AccountDisplayPrefs />} />
                <Route path={SLUGS.abha} element={<Abha />} />
                <Route path={SLUGS.hpr} element={isClinician ? <Hpr /> : <Navigate to={SLUGS.dashboard} replace />} />

                <Route path="*" element={<Navigate to={SLUGS.dashboard} replace />} />
            </Routes>
        </Suspense>
    );
}

export default PrivateRoutes;
